import React from 'react';
import '../../styles/gallery/main.css';

const Main = () => {
  return (
    <>
        <div>
            <section className="gallery-main">
                <div className="container">
                    <h1 className="my-heading mb-3">CULTURAL GALLERY</h1>
                    <ul>
                    <li>
                        <a data-bs-toggle="modal" href="#exampleModalToggle" role="button" className="btn-gallery">
                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/1.jpg" alt="gallery" />
                        </a>
                        <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle" role="button">View More</a>
                        <div>
                        <h6>Cultural</h6>
                        </div>
                    </li>
                    </ul>
                </div>
            </section>

            <div className="modal-main">
                <div className="modal fade" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                    tabindex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/1.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/2.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/3.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/4.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/5.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/6.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/7.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/8.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/9.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/10.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/11.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/12.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/13.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/14.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/15.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/16.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                            <div className="carousel-item ">
                            <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/17.jpg" className="d-block w-100" alt="Cultural" />
                            </div>
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
                            data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
                            data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                        <div className="close-btn-modal">
                            <button data-bs-dismiss="modal" aria-label="Close">
                                <i className="fa fa-times" aria-hidden="true" style={{ cursor: 'pointer' }}></i>
                            </button>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div>
                {/* Events Cultural */}
                <section className="gallery-main">
                    <div className="container">
                        <h1 className="my-heading mb-3">EVENTS GALLERY</h1>
                        <ul>
                        <li>
                            <a data-bs-toggle="modal" href="#exampleModalToggle-1" role="button" className="btn-gallery">
                            <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/events-01.jpg" alt="gallery" />
                            </a>
                            <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle-1" role="button">View More</a>
                            <div>
                            <h6>Events</h6>
                            </div>
                        </li>
                        </ul>
                    </div>
                </section>

                <div className="modal-main">
                    <div className="modal fade" id="exampleModalToggle-1" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                        tabindex="-1">
                        <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div id="carouselEvents" className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/events-01.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-02.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-03.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-04.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-05.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-06.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-07.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-08.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-09.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-10.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-11.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-12.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-13.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-14.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-15.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-16.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-17.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/events/event-18.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                            </div>
                            <button className="carousel-control-prev" type="button" data-bs-target="#carouselEvents"
                                data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#carouselEvents"
                                data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                            <div className="close-btn-modal">
                                <button data-bs-dismiss="modal" aria-label="Close">
                                    <i className="fa fa-times" aria-hidden="true" style={{ cursor: 'pointer' }}></i>
                                </button>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                {/* Independence Event */}
                <section className="gallery-main">
                    <div className="container">
                        <h1 className="my-heading mb-3">INDEPENDENCE GALLERY</h1>
                        <ul>
                        <li>
                            <a data-bs-toggle="modal" href="#exampleModalToggle-1" role="button" className="btn-gallery">
                            <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-13.jpg" alt="gallery" />
                            </a>
                            <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle-2" role="button">View More</a>
                            <div>
                            <h6>Independence Day 2025</h6>
                            </div>
                        </li>
                        </ul>
                    </div>
                </section>

                <div className="modal-main">
                    <div className="modal fade" id="exampleModalToggle-2" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                        tabindex="-1">
                        <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div id="carouselIndependence" className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-01.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-02.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-03.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-04.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-05.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-06.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-07.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-08.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-09.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-10.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-11.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-12.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-13.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-14.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/independence/inde-15.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                            </div>
                            <button className="carousel-control-prev" type="button" data-bs-target="#carouselIndependence"
                                data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#carouselIndependence"
                                data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                            <div className="close-btn-modal">
                                <button data-bs-dismiss="modal" aria-label="Close">
                                    <i className="fa fa-times" aria-hidden="true" style={{ cursor: 'pointer' }}></i>
                                </button>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                {/* Anti Ragging Event */}
                <section className="gallery-main">
                    <div className="container">
                        <h1 className="my-heading mb-3">National Anti-Ragging GALLERY</h1>
                        <ul>
                        <li>
                            <a data-bs-toggle="modal" href="#exampleModalToggle-1" role="button" className="btn-gallery">
                            <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-01.jpg" alt="gallery" />
                            </a>
                            <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle-3" role="button">View More</a>
                            <div>
                            <h6>National Anti-Ragging</h6>
                            </div>
                        </li>
                        </ul>
                    </div>
                </section>

                <div className="modal-main">
                    <div className="modal fade" id="exampleModalToggle-3" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                        tabindex="-1">
                        <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div id="carouselAntiRagging" className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-01.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-02.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-03.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-04.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-05.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-06.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-07.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-08.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-09.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-10.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-11.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-12.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-13.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-14.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-15.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-16.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-17.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                                <div className="carousel-item ">
                                <img src="https://cdn.ccsuniversity.ac.in/public/pdf/2025/08/anti-ragging/anti-18.jpg" className="d-block w-100" alt="Cultural" />
                                </div>
                            </div>
                            <button className="carousel-control-prev" type="button" data-bs-target="#carouselAntiRagging"
                                data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#carouselAntiRagging"
                                data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                            <div className="close-btn-modal">
                                <button data-bs-dismiss="modal" aria-label="Close">
                                    <i className="fa fa-times" aria-hidden="true" style={{ cursor: 'pointer' }}></i>
                                </button>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    


  )
}

export default Main;